require('plivo');

angular.module('bbl.services.plivo', [])
  .service('PlivoService', ['$q', 'Toast', '$rootScope', PlivoServiceFactory]);

var types = {
  READY: 'plivo.ready',
  LOGGED_IN: 'plivo.logged',
  TERMINATED: 'plivo.term',
  CALLING: 'plivo.calling',
  ANSWERED: 'plivo.answ',
  MEDIA_PERMISSION: 'plivo.perm'
};

var tones = [ 1,2,3,4,5,6,7,8,9,'*',0,'#' ];

function PlivoServiceFactory($q, Toast, $rootScope) {
  tones.map(function(t) { Plivo.setDtmfTone(t, null); });

  var isInitialized, loginWait, conn,
    pubsub = $rootScope.$new();

  var pub = function(topic, ps) {
    return (ps||pubsub).$emit.bind((ps||pubsub), topic);
  };

  var __init__ = function(cb) {
    Plivo.onWebrtcNotSupported = function(){
      Toast.error("Your browser doesn't support WebRTC. You need Chrome 25.", {persistent: true});
    };

    Plivo.onReady = function() { cb(Plivo.conn); };
    Plivo.onLogin = pub(types.LOGGED_IN);
    Plivo.onMediaPermission = pub(types.MEDIA_PERMISSION);
  };

  var initSDK = function(config) {
    var def = $q.defer();

    if(!isInitialized) {
      __init__(function(conn$) {
        conn = conn$;

        conn.login(config.username, config.password);
        loginWait = def.promise;

        pubsub.$on(types.LOGGED_IN, function() {
          loginWait = null;
          def.resolve(conn);
        });
      });
      Plivo.init({perm_on_click: true});
      isInitialized = true;
    }

    if(isInitialized) {
      (loginWait || $q.when()).then(function() {
        def.resolve(conn);
      });
    }

    return def.promise;
  };

  var exp;
  return (exp = {
    init: initSDK,

    makeCall: function(number) {
      if(!isInitialized) {
        throw new Error('You need to initialize the plivo sdk before making a call!');
      }

      var callPubsub = $rootScope.$new();

      initSDK().then(function(conn) {
        if (!conn) {
          return setTimeout(pub(types.TERMINATED, callPubsub));
        }

        Plivo.onCallFailed = setTimeout.bind(null, pub(types.TERMINATED, callPubsub));
        Plivo.onCalling = pub(types.CALLING, callPubsub);
        Plivo.onCallAnswered = pub(types.ANSWERED, callPubsub);
        Plivo.onCallTerminated = pub(types.TERMINATED, callPubsub);

        callPubsub.$on(types.TERMINATED, function() {
          callPubsub.$destroy();
        });

        conn.call(number);
      });

      var endOnce = function() {
        endOnce = function() {};
        pub(types.TERMINATED, callPubsub)();
      };

      return {
        types: types,
        on: callPubsub.$on.bind(callPubsub),
        end: function() { if(conn) conn.hangup(); endOnce(); },

        dtmf: function(digit) {
          if(conn) conn.send_dtmf(digit);
        },

        mute: function() { if(conn) conn.mute(); },
        unmute: function() { if(conn) conn.unmute(); },
      };
    }
  });
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/plivo-service.js
 ** module id = 157
 ** module chunks = 0
 **/